import MButtonContainer from './index.vue';

MButtonContainer.install = app => {
  app.component(MButtonContainer.name, MButtonContainer);
};

export default MButtonContainer;
